function generateStartTime(yItem) {
    const yStart = yItem.get('start');
    return (yStart || '').toString();
}

const currentWatchers = new Map();

export function yItemStartWatcher(yItem, callback) {

    if (!currentWatchers.has(yItem)) {
        const setItemStart = _.debounce(() => {
            const newStart = generateStartTime(yItem);
            const currentWatcher = currentWatchers.get(yItem);

            for (const callback of currentWatcher.callback) {
                callback(newStart);
            }
        }, 100);

        yItem.get('start').observe(setItemStart);

        currentWatchers.set(yItem, {
            setItemStart,
            callback: [],
        });
    }

    const currentWatcher = currentWatchers.get(yItem);
    currentWatcher.callback.push(callback);
    callback(generateStartTime(yItem));

    return () => {
        const currentWatcher = currentWatchers.get(yItem);

        const index = currentWatcher.callback.indexOf(callback);
        if (index !== -1) currentWatcher.callback.splice(index, 1);

        if (currentWatcher.callback.length === 0) {

            if (yItem.get('start')) {
                yItem.get('start').unobserve(
                    currentWatcher.setItemStart
                );
            }

            currentWatcher.setItemStart.cancel();
            currentWatchers.delete(yItem);
        }
    };
}
